/* LiquorVerse store rating bar — pulls the STORE aggregate from Stamped's
   public widget endpoint and reveals the bar only once real numbers land.
   Never renders a placeholder: on any failure the bar stays hidden. */
(function () {
  'use strict';

  var CACHE_KEY = 'lv-site-rating';
  var TTL_MS = 6 * 60 * 60 * 1000; /* 6h — the number moves slowly */

  function paint(el, rating, count) {
    if (!(rating > 0) || !(count > 0)) return;
    var rounded = Math.round(rating * 10) / 10;
    var score = el.querySelector('[data-lv-sr-score]');
    var cnt = el.querySelector('[data-lv-sr-count]');
    var stars = el.querySelector('[data-lv-sr-stars]');
    if (score) score.textContent = rounded.toFixed(1);
    if (cnt) cnt.textContent = count.toLocaleString();
    if (stars) {
      /* Gold overlay clipped to the exact rating — no half-star glyph, which
         isn't in most fonts and rendered as an empty box. */
      var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
      var fill = stars.querySelector('i') || stars.appendChild(document.createElement('i'));
      fill.style.width = pct + '%';
    }
    el.setAttribute(
      'aria-label',
      'Rated ' + rounded.toFixed(1) + ' out of 5 from ' + count + ' verified reviews. Read the reviews.'
    );
    el.hidden = false;
  }

  function init(el) {
    var key = el.dataset.apiKey, sid = el.dataset.sid;
    if (!key || !sid) return;

    /* Cached value paints instantly; a refresh still runs behind it. */
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.rating && c.count) paint(el, c.rating, c.count);
    } catch (e) {}

    fetch('https://stamped.io/api/widget?page=1&take=1&apiKey=' + encodeURIComponent(key) + '&sId=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var rating = parseFloat(j && j.rating);
        var count = parseInt(j && j.count, 10);
        if (!(rating > 0) || !(count > 0)) return;
        paint(el, rating, count);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ rating: rating, count: count, t: Date.now() }));
        } catch (e) {}
      })
      .catch(function () { /* stay hidden — never show a placeholder */ });
  }

  function boot() { document.querySelectorAll('[data-lv-site-rating]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
